export var CornersStyle;
(function (CornersStyle) {
  CornersStyle["Default"] = "Default";
  CornersStyle["RoundTop"] = "Round top corners";
  CornersStyle["RoundBottom"] = "Round bottom corners";
  CornersStyle["RoundAll"] = "Round all corners";
})(CornersStyle || (CornersStyle = {}));